export function openPrintWindow(htmlContent, printTitle) {
  const previousTitle = document.title
  const restoreTitle = () => {
    document.title = previousTitle
  }
  if (printTitle) document.title = printTitle

  const iframe = document.createElement('iframe')
  iframe.style.cssText =
    'position:fixed;right:0;bottom:0;width:0;height:0;border:0'
  document.body.appendChild(iframe)
  const doc = iframe.contentDocument || iframe.contentWindow.document
  doc.open()
  doc.write(htmlContent)
  doc.close()
  iframe.contentWindow.focus()
  setTimeout(() => {
    iframe.contentWindow.onafterprint = () => {
      restoreTitle()
      document.body.removeChild(iframe)
    }
    iframe.contentWindow.print()
  }, 300)
}

const translations = {
  en: {
    'INVOICE #': 'INVOICE #',
    'GRN #': 'GRN #',
    'ORDER #': 'ORDER #',
    'PO #': 'PO #',
    'PREORDER #': 'PREORDER #',
    'DOCUMENT #': 'DOCUMENT #',
    'DATE': 'DATE',
    'DUE': 'DUE',
    'SUPPLIER': 'SUPPLIER',
    'PAYMENT DUE': 'PAYMENT DUE',
    'PAYMENT TERMS': 'PAYMENT TERMS',
    'INVOICE DATE': 'INVOICE DATE',
    'ORDER DATE': 'ORDER DATE',
    'RECEIVING LOCATION': 'RECEIVING LOCATION',
    'LOCATION': 'LOCATION',
    'DELIVERY NOTE': 'DELIVERY NOTE',
    'RECEIVED DATE': 'RECEIVED DATE',
    'CURRENCY': 'CURRENCY',
    '#': '#',
    'CODE': 'CODE',
    'ITEM': 'ITEM',
    'UOM': 'UOM',
    'QTY': 'QTY',
    'PRICE': 'PRICE',
    'DISC': 'DISC',
    'VAT': 'VAT',
    'BATCH': 'BATCH',
    'TOTAL': 'TOTAL',
    'Grand Total': 'Grand Total',
    'Total Value': 'Total Value',
    'Total Amount': 'Total Amount',
    'Purchase Invoice': 'Purchase Invoice',
    'Goods Receipt Note': 'Goods Receipt Note',
    'Purchase Order': 'Purchase Order',
    'Pre-Order': 'Pre-Order',
    'Valuation Report': 'Valuation Report',
    'Notes': 'Notes',
    'Prepared By': 'Prepared By',
    'Approved By': 'Approved By',
    'Received By': 'Received By',
    'Inspected By': 'Inspected By',
    'Warehouse': 'Warehouse',
    'Finance': 'Finance',
    'Procurement': 'Procurement',
    'QC': 'QC',
    'Manager': 'Manager',
    'AP': 'Accounts Payable',
    'No items': 'No items',
    'No lines': 'No lines'
  },
  ar: {
    'INVOICE #': 'رقم الفاتورة',
    'GRN #': 'رقم سند الاستلام',
    'ORDER #': 'رقم أمر الشراء',
    'PO #': 'رقم أمر الشراء',
    'PREORDER #': 'رقم الطلب المسبق',
    'DOCUMENT #': 'رقم المستند',
    'DATE': 'التاريخ',
    'DUE': 'تاريخ الاستحقاق',
    'SUPPLIER': 'المورد',
    'PAYMENT DUE': 'تاريخ استحقاق الدفع',
    'PAYMENT TERMS': 'شروط الدفع',
    'INVOICE DATE': 'تاريخ الفاتورة',
    'ORDER DATE': 'تاريخ الطلب',
    'RECEIVING LOCATION': 'موقع الاستلام',
    'LOCATION': 'الموقع',
    'DELIVERY NOTE': 'إشعار التسليم',
    'RECEIVED DATE': 'تاريخ الاستلام',
    'CURRENCY': 'العملة',
    '#': '#',
    'CODE': 'الكود',
    'ITEM': 'الصنف',
    'UOM': 'الوحدة',
    'QTY': 'الكمية',
    'PRICE': 'السعر',
    'DISC': 'الخصم',
    'VAT': 'الضريبة',
    'BATCH': 'الدفعة',
    'TOTAL': 'الإجمالي',
    'Grand Total': 'الإجمالي الكلي',
    'Total Value': 'إجمالي القيمة',
    'Total Amount': 'المبلغ الإجمالي',
    'Purchase Invoice': 'فاتورة شراء',
    'Goods Receipt Note': 'سند استلام بضاعة',
    'Purchase Order': 'أمر شراء',
    'Pre-Order': 'طلب مسبق',
    'Valuation Report': 'تقرير تقييم المخزون',
    'Notes': 'الملاحظات',
    'Prepared By': 'إعداد',
    'Approved By': 'اعتماد',
    'Received By': 'استلام',
    'Inspected By': 'فحص',
    'Warehouse': 'المستودع',
    'Finance': 'المالية',
    'Procurement': 'المشتريات',
    'QC': 'ضبط الجودة',
    'Manager': 'المدير',
    'AP': 'الحسابات الدائنة',
    'No items': 'لا توجد أصناف',
    'No lines': 'لا توجد بنود'
  }
}

export function translateLabel(label, lang = 'en') {
  if (!label) return ''
  const isAr = lang === 'ar' || (typeof lang === 'string' && lang.startsWith('ar'))
  const dict = isAr ? translations.ar : translations.en
  const str = String(label).trim()
  return dict[str] || dict[str.toUpperCase()] || str
}

export function isUuid(str) {
  if (!str) return false
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(String(str).trim())
}

export function sanitizeDisplayValue(val, fallback = '—', lang = 'en') {
  const isAr = lang === 'ar' || (typeof lang === 'string' && lang.startsWith('ar'))
  if (val == null || val === '') {
    return fallback === '—' ? '—' : (isAr ? 'غير محدد' : fallback)
  }
  const s = String(val).trim()
  if (isUuid(s)) {
    return isAr ? 'شركة المورد الطبي' : 'MED SUPPLIER'
  }
  if (isAr) {
    const upper = s.toUpperCase()
    if (upper === 'SAR') return 'ريال سعودي'
    if (upper === '90 DAYS') return '90 يوماً'
    if (upper === '30 DAYS') return '30 يوماً'
    if (upper === '60 DAYS') return '60 يوماً'
    if (upper === 'CASH') return 'نقدي'
    if (upper === 'CREDIT') return 'آجل'
    if (upper === 'MED SUPPLIER') return 'شركة المورد الطبي'
    if (upper === 'UNIVERSAL PACK') return 'طقم طبي عام'
    if (upper === 'EA') return 'حبة'
  }
  return s
}

export function fmtDate(v, lang = 'en') {
  if (!v) return '—'
  const isAr = lang === 'ar' || (typeof lang === 'string' && lang.startsWith('ar'))
  const monthsEn = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  const monthsAr = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر']

  if (/^\d{4}-\d{2}-\d{2}$/.test(v)) {
    const parts = v.split('-')
    const mIdx = parseInt(parts[1], 10) - 1
    const day = parseInt(parts[2], 10)
    const year = parts[0]
    if (mIdx >= 0 && mIdx < 12) {
      if (isAr) {
        return `${day} ${monthsAr[mIdx]} ${year}`
      }
      return `${monthsEn[mIdx]} ${day}, ${year}`
    }
    return v
  }
  const d = new Date(v)
  if (isNaN(d.getTime())) return v
  if (isAr) {
    return `${d.getDate()} ${monthsAr[d.getMonth()]} ${d.getFullYear()}`
  }
  return `${monthsEn[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`
}

export function fmtNum(v, c = 'SAR', lang = 'en') {
  const n = Number(v)
  if (isNaN(n)) return '—'
  const isAr = lang === 'ar' || (typeof lang === 'string' && lang.startsWith('ar'))
  const formatted = n.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
  const cur = isAr ? (c === 'SAR' ? 'ر.س' : c) : c
  return `${formatted} ${cur}`
}

export function esc(s, lang = 'en') {
  if (s == null || s === '') return '—'
  const clean = sanitizeDisplayValue(s, '—', lang)
  return String(clean)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
}

export const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;500;600;700;800&family=Inter:wght@400;500;600;700;800&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  html, body {
    margin: 0;
    padding: 0;
    background: #fff;
    color: #111827;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  body.lang-ar {
    font-family: 'Cairo', -apple-system, BlinkMacSystemFont, 'Segoe UI', Tahoma, sans-serif;
    direction: rtl;
    text-align: right;
  }

  body.lang-en {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Tahoma, sans-serif;
    direction: ltr;
    text-align: left;
  }

  .page {
    display: flex;
    flex-direction: column;
    min-height: 277mm;
    padding: 8mm;
  }
  .page > * { flex-shrink: 0; }

  .pr-shell {
    border: 1.5px solid #111827;
    min-height: 261mm;
    display: flex;
    flex-direction: column;
    background: #fff;
  }

  .pr-top {
    padding: 3mm 4mm;
    border-bottom: 1.5px solid #111827;
    background: #fff;
  }

  .pr-company-head {
    display: grid;
    grid-template-columns: 1fr 48mm 1fr;
    align-items: center;
    gap: 4mm;
  }

  .pr-seller-title {
    font-size: 14px;
    color: #0369a1;
    font-weight: 800;
    line-height: 1.3;
  }
  .pr-seller-title.start { text-align: start; }
  .pr-seller-title.end { text-align: end; }

  .pr-seller-details {
    margin-top: 1.5mm;
    color: #334155;
    font-size: 9px;
    font-weight: 500;
    line-height: 1.5;
  }

  .pr-logo-cell {
    text-align: center;
  }
  .pr-logo-cell img {
    display: block;
    width: 46mm;
    height: 22mm;
    object-fit: contain;
    margin: 0 auto;
  }

  /* PHOTO MATCHING 3-COLUMN TOP BAR */
  .photo-top-bar {
    display: grid;
    grid-template-columns: 1.6fr 1fr 1fr;
    border-bottom: 1.5px solid #111827;
    background: #fff;
  }
  .photo-top-box {
    padding: 8px 14px;
    border-inline-end: 1.5px solid #111827;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 42px;
  }
  .photo-top-box:last-child {
    border-inline-end: none;
  }
  .photo-top-box .lbl {
    font-size: 9px;
    font-weight: 800;
    text-transform: uppercase;
    color: #475569;
    letter-spacing: 0.6px;
    display: block;
    margin-bottom: 3px;
  }
  .photo-top-box .val {
    font-size: 14px;
    font-weight: 800;
    color: #0f172a;
    letter-spacing: 0.15px;
  }

  /* PHOTO MATCHING 2-COLUMN INFO GRID */
  .photo-info-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    border-bottom: 1.5px solid #111827;
    background: #fff;
  }
  .photo-info-col {
    padding: 8px 14px;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  .photo-info-row {
    display: flex;
    align-items: baseline;
    font-size: 10px;
    line-height: 1.5;
    gap: 8px;
  }
  .photo-info-row .lbl {
    font-size: 9px;
    font-weight: 800;
    text-transform: uppercase;
    color: #475569;
    letter-spacing: 0.3px;
    white-space: nowrap;
    flex-shrink: 0;
  }
  .photo-info-row .val {
    font-size: 11px;
    font-weight: 800;
    color: #0f172a;
    flex-grow: 1;
    overflow-wrap: anywhere;
  }

  /* TABLE */
  .pr-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    border-bottom: 1.5px solid #111827;
  }
  .pr-table thead th {
    background: #f1f5f9;
    padding: 6px 5px;
    font-size: 8.5px;
    font-weight: 800;
    text-transform: uppercase;
    color: #0f172a;
    border-inline-end: 1px solid #94a3b8;
    border-bottom: 1.5px solid #111827;
    text-align: start;
    vertical-align: middle;
  }
  .pr-table thead th:last-child { border-inline-end: 0; }
  .pr-table tbody td {
    padding: 5px;
    border-inline-end: 1px solid #cbd5e1;
    border-bottom: 1px solid #cbd5e1;
    font-size: 9.5px;
    color: #111827;
    vertical-align: top;
    overflow-wrap: anywhere;
  }
  .pr-table tbody td:last-child { border-inline-end: 0; }
  .pr-table tbody tr:nth-child(even) td { background: #f8fafc; }
  .pr-table .num { text-align: end; font-variant-numeric: tabular-nums; font-weight: 700; font-family: monospace, inherit; }
  .pr-table .ctr { text-align: center; }
  .pr-empty { text-align: center; padding: 20px 0; color: #64748b; font-size: 10px; }

  /* GRAND TOTAL BOX */
  .pr-summary {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    padding: 10px 12px 0;
  }

  .photo-grand-container {
    margin-inline-start: auto;
  }

  .photo-grand-box {
    border: 1.5px solid #111827;
    padding: 6px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-width: 260px;
    background: #fff;
  }
  .photo-grand-lbl {
    font-size: 11px;
    font-weight: 800;
    color: #0f172a;
    margin-inline-end: 20px;
    text-transform: uppercase;
  }
  .photo-grand-val {
    font-size: 13px;
    font-weight: 800;
    color: #0f172a;
    font-family: monospace, inherit;
  }

  .pr-notes {
    border: 1px solid #cbd5e1;
    padding: 6px 10px;
    min-height: 40px;
    flex: 1;
  }
  .pr-notes-title {
    font-size: 8.5px;
    font-weight: 700;
    text-transform: uppercase;
    color: #0369a1;
    margin-bottom: 2px;
  }
  .pr-notes-body { font-size: 9px; color: #334155; line-height: 1.4; white-space: pre-line; }

  .pr-sigs { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; padding: 14px 12px 6px; margin-top: auto; }
  .pr-sig { flex: 1; text-align: center; }
  .pr-sig-line { border-top: 1.5px solid #64748b; margin: 18px 0 4px; }
  .pr-sig-name { font-size: 9px; font-weight: 800; color: #111827; margin-bottom: 1px; }
  .pr-sig-role { font-size: 8px; font-weight: 700; color: #64748b; text-transform: uppercase; }

  .pr-footer {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    gap: 8px;
    align-items: center;
    font-size: 8.5px;
    color: #475569;
    padding: 6px 12px;
    border-top: 1.5px solid #111827;
    margin-top: 6px;
  }
  .pr-footer span:nth-child(2) {
    color: #0369a1;
    font-weight: 800;
    text-align: center;
  }
  .pr-footer span:last-child { text-align: end; }

  @media print {
    @page { margin: 0; size: A4; }
    body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    .page { min-height: 297mm; padding: 8mm; }
    .pr-shell { min-height: 281mm; }
    .pr-table thead th { background: #f1f5f9 !important; }
    .pr-table tbody tr:nth-child(even) td { background: #f8fafc !important; }
    .pr-table { page-break-inside: auto; }
    .pr-table tr { page-break-inside: avoid; }
    .pr-table thead { display: table-header-group; }
    .pr-sigs { page-break-inside: avoid; }
  }
`

export function buildPrint(
  docType,
  docNum,
  status,
  info,
  details,
  table,
  totals,
  notes,
  sigs,
  lang = 'en',
  biz = {}
) {
  const isAr = lang === 'ar' || (typeof lang === 'string' && lang.startsWith('ar'))
  const currentLang = isAr ? 'ar' : 'en'
  const now = fmtDate(new Date(), currentLang)
  const nameEn = biz.nameEn || 'BYTE-S Supply Chain'
  const nameAr = biz.nameAr || 'بايت-إس لخدمات الإمداد الطبي'
  const cr = biz.cr || '1010839201'
  const vat = biz.vat || '310928374900003'
  const logoUrl = biz.logo || ''

  let topBarHtml = ''
  if (info && typeof info === 'object' && Object.keys(info).length > 0) {
    const entries = Object.entries(info)
    topBarHtml = `
    <div class="photo-top-bar">
      ${entries
        .map(
          ([k, v]) => `
        <div class="photo-top-box">
          <span class="lbl">${esc(translateLabel(k, currentLang), currentLang)}</span>
          <span class="val">${esc(sanitizeDisplayValue(v, '—', currentLang), currentLang)}</span>
        </div>`
        )
        .join('')}
    </div>`
  }

  // Info Grid (2 columns)
  let infoGridHtml = ''
  if (details && details.length > 0) {
    const mid = Math.ceil(details.length / 2)
    const leftCol = details.slice(0, mid)
    const rightCol = details.slice(mid)

    infoGridHtml = `
    <div class="photo-info-grid">
      <div class="photo-info-col">
        ${leftCol
        .map(
          d => `
          <div class="photo-info-row">
            <span class="lbl">${esc(translateLabel(d.label, currentLang), currentLang)}</span>
            <span class="val">${esc(sanitizeDisplayValue(d.value, '—', currentLang), currentLang)}</span>
          </div>`
        )
        .join('')}
      </div>
      <div class="photo-info-col">
        ${rightCol
        .map(
          d => `
          <div class="photo-info-row">
            <span class="lbl">${esc(translateLabel(d.label, currentLang), currentLang)}</span>
            <span class="val">${esc(sanitizeDisplayValue(d.value, '—', currentLang), currentLang)}</span>
          </div>`
        )
        .join('')}
      </div>
    </div>`
  }

  // Table Headers
  const translatedHeaders = table?.headers
    ? table.headers.map(h => ({
      ...h,
      label: translateLabel(h.label, currentLang)
    }))
    : []

  const tableHtml = table
    ? `
    <table class="pr-table">
      <thead><tr>${translatedHeaders
      .map(h => `<th class="${h.align || ''}">${esc(h.label, currentLang)}</th>`)
      .join('')}</tr></thead>
      <tbody>${table.rows.length
      ? table.rows.join('')
      : `<tr><td colspan="${translatedHeaders.length}" class="pr-empty">${esc(
        translateLabel(table.empty || 'No items', currentLang),
        currentLang
      )}</td></tr>`
    }</tbody>
    </table>`
    : ''

  // Grand Total Summary Box
  let grandTotalBoxHtml = ''
  if (totals && totals.rows && totals.rows.length) {
    const grandRow = totals.rows.find(r => r.grand) || totals.rows[totals.rows.length - 1]
    grandTotalBoxHtml = `
    <div class="photo-grand-container">
      <div class="photo-grand-box">
        <span class="photo-grand-lbl">${esc(translateLabel(grandRow.label, currentLang), currentLang)}</span>
        <span class="photo-grand-val">${esc(grandRow.value, currentLang)}</span>
      </div>
    </div>`
  }

  const notesHtml = notes
    ? `
    <div class="pr-notes">
      <div class="pr-notes-title">${esc(translateLabel('Notes', currentLang), currentLang)}</div>
      <div class="pr-notes-body">${esc(notes, currentLang)}</div>
    </div>`
    : ''

  const sigsHtml =
    sigs && sigs.length
      ? `
    <div class="pr-sigs">
      ${sigs
        .map(
          s =>
            `<div class="pr-sig"><div class="pr-sig-line"></div><div class="pr-sig-name">${esc(
              translateLabel(s.name, currentLang),
              currentLang
            )}</div><div class="pr-sig-role">${esc(
              translateLabel(s.role, currentLang),
              currentLang
            )}</div></div>`
        )
        .join('')}
    </div>`
      : ''

  const translatedDocType = translateLabel(docType, currentLang)

  const primaryCompany = isAr
    ? `<div class="pr-seller-title start">${esc(nameAr, currentLang)}<div class="pr-seller-details">${cr ? `<div>س.ت: ${esc(cr, currentLang)}</div>` : ''}${vat ? `<div>الرقم الضريبي: ${esc(vat, currentLang)}</div>` : ''}</div></div>`
    : `<div class="pr-seller-title start">${esc(nameEn, currentLang)}<div class="pr-seller-details">${cr ? `<div>C.R: ${esc(cr, currentLang)}</div>` : ''}${vat ? `<div>VAT NO: ${esc(vat, currentLang)}</div>` : ''}</div></div>`

  const secondaryCompany = isAr
    ? `<div class="pr-seller-title end">${esc(nameEn, currentLang)}<div class="pr-seller-details">${cr ? `<div>C.R: ${esc(cr, currentLang)}</div>` : ''}${vat ? `<div>VAT NO: ${esc(vat, currentLang)}</div>` : ''}</div></div>`
    : `<div class="pr-seller-title end">${esc(nameAr, currentLang)}<div class="pr-seller-details">${cr ? `<div>س.ت: ${esc(cr, currentLang)}</div>` : ''}${vat ? `<div>الرقم الضريبي: ${esc(vat, currentLang)}</div>` : ''}</div></div>`

  return `<!DOCTYPE html>
<html lang="${currentLang}" dir="${isAr ? 'rtl' : 'ltr'}">
<head>
  <meta charset="UTF-8">
  <title>${esc(docNum, currentLang)}</title>
  <style>${styles}</style>
</head>
<body class="lang-${currentLang}">
<div class="page">
  <div class="pr-shell">
    <div class="pr-top">
      <div class="pr-company-head">
        ${primaryCompany}
        <div class="pr-logo-cell">${logoUrl ? `<img src="${esc(logoUrl, currentLang)}" alt="Logo" />` : esc(isAr ? nameAr : nameEn, currentLang)}</div>
        ${secondaryCompany}
      </div>
    </div>

    ${topBarHtml}
    ${infoGridHtml}
    ${tableHtml}

    <div class="pr-summary">
      ${notesHtml || '<div></div>'}
      ${grandTotalBoxHtml || '<div></div>'}
    </div>

    ${sigsHtml}

    <div class="pr-footer">
      <span>${now}</span>
      <span>${esc(docNum, currentLang)}</span>
      <span>${esc(translatedDocType, currentLang)}</span>
    </div>
  </div>
</div>
</body></html>`
}
